import { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
} from '@mui/material';
import { toast } from 'react-toastify';

export default function DeleteCallModal({ open, onClose, onDelete, callId }) {
  const [deletedReason, setDeletedReason] = useState('');

  const handleDelete = async () => {
    if (!deletedReason.trim()) {
      toast.error('Bitte gebe einen Grund für die Löschung an.');
      return;
    }

    try {
      const response = await onDelete(callId, deletedReason);
      onClose();
      setDeletedReason('');
      return response;
    } catch (error) {
      toast.error('Fehler beim Löschen des Anrufs.');
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth='sm' fullWidth>
      <DialogTitle>Anruf löschen</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin='dense'
          label='Grund für die Löschung'
          type='text'
          fullWidth
          variant='outlined'
          value={deletedReason}
          onChange={e => setDeletedReason(e.target.value)}
          multiline
          rows={3}
        />
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            setDeletedReason('');
            onClose();
          }}
        >
          Abbrechen
        </Button>
        <Button
          onClick={handleDelete}
          color='error'
          variant='contained'
          disabled={!deletedReason.trim()}
        >
          Löschen
        </Button>
      </DialogActions>
    </Dialog>
  );
}
